module.exports = __webpack_public_path__ + "media/team_admin/morterboard-6e7668e9.png";